import React, { useState, useEffect, Fragment, useContext } from "react"
import { useGlobalState } from "../../../GlobalState"
import { withRouter } from "react-router-dom"
import { useTranslation } from "react-i18next"
import {
  Drawer,
  DrawerContent,
  DrawerItem,
} from "@progress/kendo-react-layout"
import { Tooltip } from "@progress/kendo-react-tooltip"
import {
  newConfigurationIcon,
  notificationIcon,
  urgentNotificationIcon,
  notificationSmallIcon,
  DefaultUserImage,
  LogoutIcon
} from "../../../assets/logos/icons"
import {
  DialogSystemGLPure,
  DialogTimerSignOff,
  NotificationSliderPure,
  SliderPure,
  TooltipHLPure,
  ModalUtil,
  DialogAddBotPure
} from "../../pures"
import { useMediaQuery } from '@material-ui/core'
import "./app.css"
import { Avatar } from "@progress/kendo-react-layout"

import { Context } from "../../../Context"
import { Switch } from "@progress/kendo-react-inputs"
import { DropDownList } from '@progress/kendo-react-dropdowns'

/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 * @description Custom component for each Item in Drawer
 */
const CustomItem = (props) => {
  const { visible, ...others } = props
  const drawerImageItemMenuStyles = {
    height: "30px",
    width: "100%",
    objectFit: "contain",
  }

  const smallmatches = useMediaQuery("(max-width:800px)")

  const drawerTextItemMenuStyles = {
    color: "#4A4A4A",
    fontSize: "14px",
    overflow: "hidden",
    fontWeight: "600",
    lineHeight: "1.25em",
  }
  const draweItemsStyle = {
    alignItems: "center",
    margin: "5px",
  }
  if (smallmatches) {
    drawerTextItemMenuStyles.display = "none"
  }
  const drawerTextItemSubMenuStyles = {
    marginLeft: "15px",
    marginRight: "13px",
    fontWeight: 500,
    fontSize: "15px",
    color: "#4D4D4D",
  }

  return (
    <Tooltip
      openDelay={600}
      position="right"
      anchorElement="target"
      tooltipClassName="tooltipGeneralStyle"
    >
      {props.parentId === 1 ? (
        <DrawerItem {...others}>
          <div className="drawer-item-elem">
            <div style={draweItemsStyle}>
              <div style={{ display: "flex", alignItems: "center", paddingLeft: "5%", gap: "8px" }}>
                <div style={{ flexShrink: 0, display: 'flex' }}>
                  <img
                    alt="Icono del menu"
                    src={props.icon}
                    style={drawerImageItemMenuStyles}
                    title={props.tooltipText}
                  />
                </div>
                <p style={drawerTextItemMenuStyles} title={props.tooltipText}>
                  {props.text}
                </p>
              </div>
            </div>
          </div>
        </DrawerItem>
      ) : (
        <DrawerItem {...others}>
          <div className="drawer-item-elem">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="icon-visibility" title={props.tooltipText}>
                {props.text
                  .match(/\b\w/g)
                  .toString()
                  .toUpperCase()
                  .replace(/,/g, "")}
              </span>
              <span
                className={"k-item-text"}
                style={drawerTextItemSubMenuStyles}
                title={props.tooltipText}
              >
                {props.text}
              </span>
            </div>
          </div>
        </DrawerItem>
      )}
    </Tooltip >
  )
}


/* Component to render configuration icon in header */
/**
 * @status no delete
 * @param {*} { contract, userType }
 * @return {*} 
 */
const ConfigurationIconTop = ({ contract, handleClickSlideBar }) => {

  let { contractExist, contractsStatus, userHadContracts } = contract

  if (
    contractExist &&
    userHadContracts &&
    contractsStatus ===
    Number(process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING)
  ) {
    return null
  }

  return (
    <button onClick={handleClickSlideBar} className="icon-button">
      <img
        alt="config-icon"
        src={newConfigurationIcon}
        title="Configuración"
        className="config-icon"
      />
    </button>
  )
}

/* === Component Drawer and container of App === */

/**
 * @status no delete
 * @param {*} props
 * @return {*} 
 */
const AppView = (props) => {
  // #region variables
  const { navActions } = useContext(Context)
  const modalUtil = new ModalUtil()

  const [showSideMenuExpanded, setShowSideMenuExpanded] = useState(
    props.expanded
  )

  const { t, i18n } = useTranslation()
  function handleClickDropdown(location) {
    window.location.replace(`#/${location}`)
  }

  let selected = props.setSelectedItem(props.location.pathname)

  const [options, setOptions] = useState([
    <button onClick={(e) => { handleClickDropdown("profile") }}>{t("profile.slidePanel.profileOption")}</button>,
    <button onClick={(e) => { handleClickDropdown("client-profile") }}>{t("profile.slidePanel.clientOption")}</button>
  ])
  
  const settingsOptions = ([
    <button onClick={() => { handleClickDropdown("domain-administration") }}>{t("settings.slidePanel.domainAuthorization")}</button>,
    <button onClick={() => { handleClickDropdown("branch-offices-administration") }}>{t("settings.slidePanel.branchOffices")}</button>,
    <button onClick={() => { handleClickDropdown("user-administration") }}>{t("settings.slidePanel.userAdministration")}</button>,
    <button onClick={() => { handleClickDropdown("group-administration") }}>{t("settings.slidePanel.groupsAdministration")}</button>,
    <button onClick={() => { handleClickDropdown('bot-administration') }}>{t('settings.slidePanel.botAdministration')}</button>
    // <button onClick={() => { handleClickDropdown("assistant-configuration") }}>{t("settings.slidePanel.assistantAdministration")}</button>
    // <button onClick={() => { handleClickDropdown("customization") }}>{t("settings.slidePanel.customizeAccount")}</button>
  ])
  
  const { botConfig, setBotConfig, chatbotList } = useGlobalState()
  const [showModalAddBot, setShowModalAddBot] = useState(false)
  // #endregion variables

  // #region effects
  useEffect(() => {
    setShowSideMenuExpanded(props.expanded)
    if (props.matchMobileResolution) {
      setShowSideMenuExpanded(!props.expanded)
    }
  }, [props.expanded, props.matchMobileResolution])

  useEffect(() => {
    props.handleGetAssistants(true)
    //This are examples of how implements the react flag to show and block menu options
    // if (!Boolean(Number(process.env.REACT_APP_FEATURE_FLAG))) {
    // setOptions([...options,
    //   <button onClick={(e) => { handleClickDropdown("") }}>{t("profile.slidePanel.billing")}</button>,
    //   <button onClick={(e) => { handleClickDropdown("") }}>{t("profile.slidePanel.help")}</button>])

    //   setSettingsOptions([ <button onClick={() => { handleClickDropdown("domain-administration") }}>{t("settings.slidePanel.domainAuthorization")}</button>])
    // }
  }, [])
  // #endregion effects

  // #region code
  props.checkForAuthorization(props.history)
  props.checkForSignRequest(props.history)
  // #endregion code

  // #region methods
  const changeLanguage = async (e) => {
    let lng = 'en'
    if (e.target.value) lng = 'es-MX'
    i18n.changeLanguage(lng)
    await props.changeLanguage(lng)
  }
  // #endregion methods

  // #region jsx-elements
  const contentButtonAddBot = (
    <Fragment>
      <li
        role='option'
        className='k-list-item'
        onClick={() => setShowModalAddBot(true)}
      >
        <span className='k-list-item-text new-asistant-button'>{t('botConfig.addButton')}</span>
      </li>
    </Fragment>
  )

  const contentItemAssistant = (li, itemProps) => {
    const itemChildren = <Fragment>
      <li
        role='option'
        className='k-list-item assistant-item-list'
        onClick={() => setBotConfig(itemProps.dataItem)}
      >
          <span className='k-list-item-text'>{itemProps.dataItem.chatbotName}</span>
      </li>
        <div className='assistant-item-actions'>
          <button
            key={itemProps.dataItem.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            className='gridPure-cellActions-IconBtn'
            onClick={() => deleteChatbot(itemProps.dataItem.id)}
          >
            <i style={{ pointerEvents: 'none' }}
              className='k-icon k-i-delete k-i-trash'
            ></i>
          </button>
        </div>
    </Fragment>
    return React.cloneElement(li, li.props, itemChildren)
  }

  const contentAssistantIcon = (
    <TooltipHLPure
      descriptionTooltip={t('botConfig.icon')}
      positionTooltip='bottom'
      customImg={process.env.REACT_APP_ASSISTANT_ICON}
      altCustomImg='assistant-icon'
      styleCustomImg={'assistant-icon'}
      />
  )

  const deleteChatbot = async (id) => {
    await modalUtil.showConfirmModal(
        t('modal.pure.title.confirm'),
        t('modal.pure.confirm.delete.chatbot'),
        t('modal.pure.button.yes'),
        t('modal.pure.button.no'),
        async () => {
        modalUtil.showModal('loading', t('modal.pure.loading.message'), t('modal.pure.loading.title'))

        try {
            await props.handleDeactivateAssistant(id)
            modalUtil.showModal('success', t('modal.pure.success.delete.chatbot'), t('modal.pure.title.success'))
        } catch (error) {
            modalUtil.showModal('error', error.message || t('modal.pure.error.delete.chatbot'), t('modal.pure.title.error'))
        }
        },
        () => {
        // Opcional: Cancel action
        }
    )
  }
  // #endregion jsx-elements

  return (
    <Fragment>
      <div className="app-view">
        {/* Help Section Icon */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: "10px",
          }}
        >
          <div className="help-profile-icons">
            <div className='assistant-content'>
              {contentAssistantIcon}
              <DropDownList
                  id='assistantProfile'
                  name={'assistantProfile'}
                  className="assistant-profile-dropdown-field"
                  textField="chatbotName"
                  dataItemKey="id"
                  data={chatbotList.filter(bot => bot.active)}
                  value={botConfig}
                  footer={contentButtonAddBot}
                  itemRender={contentItemAssistant}
                  style={{ width: '200px', maxWidth: '200px', height: '30px' }}
              />
            </div>
            {
              navActions.notifications &&
              <button onClick={props.toggleNotification} className='notification-icon'>
                <img
                  alt="notification-icon"
                  src={
                    props.notificationQuantity > 0
                      ? notificationSmallIcon
                      : notificationIcon
                  }
                  title="Notificaciones"
                  className='notification-icon-filter'
                />
                {props.notificationQuantity > 0 ? (
                  props.notificationQuantity > 9 ? (
                    <span className='icon-button-badge notification-badge-font-10'>+9</span>
                  ) : (
                    <span className="icon-button-badge">
                      {props.notificationQuantity}
                    </span>
                  )
                ) : null}
              </button>
            }

            {
              navActions.settings &&
              <ConfigurationIconTop
                contract={props.contract.data}
                userType={props.userType}
                handleClickSlideBar={props.toggleSettingSlideBar}
              />
            }

            {
              navActions.profile &&
              <button title={props.userName} onClick={props.toggleProfileSlideBar} className="icon-button avatar-button">
                {props.userPathImage ? (
                  <Avatar
                    shape="circle"
                    type="image"
                    themeColor="inherit"
                  >
                    <img
                      src={props.userPathImage}
                      alt="user-img"
                      className="k-avatar-image"
                      style={{ borderRadius: "50%", cursor: "pointer" }}
                      title={props.userName}
                    />
                  </Avatar>
                ) : (
                  <img
                    src={DefaultUserImage}
                    alt="profile icon"
                    height="30px"
                    title="Perfil"
                  />
                )}
              </button>
            }
          </div>

          {/* Notification Section Slider Panel*/}
          {
            navActions.notifications &&
            <NotificationSliderPure
              initializeNotification={props.initializeNotification}
              showNotification={props.showNotification}
              toggleNotification={props.toggleNotification}
              playSound={props.playSound}
              toggleSoundActive={props.toggleSoundActive}
              soundActive={props.soundActive}
              onUpdateSocket={props.onUpdateSocket}
              socketNotifications={props.notifications}
              onPinNotification={props.onPinNotification}
              onDisableNotification={props.onDisableNotification}
              onAssistChat={props.onAssistChat}
            ></NotificationSliderPure>
          }
          {
            navActions.settings &&
            <SliderPure
              initializeNotification={props.initializeSettingSection}
              showNotification={props.showSettingSlideBar}
              toggleNotification={props.toggleSettingSlideBar}
              title={t("settings.slidePanel.title")}
              options={settingsOptions}
              showEndPanel={<div className="settingsPanel-footer">
                <p>{t('language')}</p>
                <label className="settingsPanel-footer-switch" htmlFor="language-switch">
                  <span>EN</span>
                  <Switch onChange={changeLanguage} checked={i18n.language === 'es-MX'} id="language-switch" size='small' trackRounded='full' thumbRounded='full' />
                  <span>ES</span>
                </label>
              </div>}
            ></SliderPure>
          }

          {
            navActions.profile &&
            <SliderPure
              initializeNotification={props.initializeProfileSection}
              showNotification={props.showProfileSlideBar}
              toggleNotification={props.toggleProfileSlideBar}
              title={t("profile.slidePanel.title")}
              options={options}
              showEndPanel={<div className="notificationPanel-footer">
                <button style={{ cursor: 'pointer', background: 'transparent', border: 'none', color: 'white', fontFamily: 'inherit', fontWeight: 500 }} onClick={(e) => { props.handleButtonLogOut() }}>{t("profile.slidePanel.logout")}</button>
              </div>}
            ></ SliderPure>
          }
        </div>

        <Drawer
          expanded={showSideMenuExpanded} // || displayDrawer
          className={(props.expanded ? "" : "isDrawerOpen", "app-resize")}
          position="start"
          mode={props.matchMobileResolution ? "overlay" : "push"}
          items={
            !Boolean(Number(process.env.REACT_APP_FEATURE_FLAG)) ?
              props.items
                .map((item) => ({
                  ...item,
                  selected: item.text === selected,
                  contract: props.contract.data,
                  userType: props.userType,
                  text: t(item.text),
                  tooltipText: t(item.tooltipText),
                }))
                .filter(
                  (item) =>
                    item.route !== "/profile" && item.route !== "/configuration"
                )
              :
              props.items
                .map((item) => ({
                  ...item,
                  selected: item.text === selected,
                  contract: props.contract.data,
                  userType: props.userType,
                  text: t(item.text),
                  tooltipText: t(item.tooltipText),
                }))
                .filter(
                  (item) =>
                    item.route !== "/profile" && item.route !== "/configuration"
                )
          }
          item={CustomItem}
          animation={{ duration: 400 }}
          onSelect={(event) => {
            if (
              event.itemTarget.props.route === "/" &&
              props.contract.data.contractsStatus ===
              Number(process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING)
            ) {
              props.history.push("/waiting-authorization")
            } else {
              props.onSelect(event, props.history)
            }
          }}
          onOverlayClick={props.toggleExpandedSideMenu}
        >
          <DrawerContent>
            <div className="div-con-fondo">{props.children}</div>
          </DrawerContent>
        </Drawer>

        {/* Alerts of Notification Loading, Completed and Error */}
        <DialogSystemGLPure
          {...props}
          toggleLoadingRequesting={props.toggleLoadingRequesting}
          toggleCompletedRequesting={props.toggleCompletedRequesting}
          toggleErrorRequesting={props.toggleErrorRequesting}
        />

        {/* Timer to sign off the sesion in application */}
        <DialogTimerSignOff
          {...props}
          toggleDialogTimerSignOff={props.toggleDialogTimerSignOff}
          onSignOffByTimerEnd={props.onSignOffByTimerEnd}
          onSignOffByUser={props.onSignOffByUser}
          onRefreshUserToken={props.onRefreshUserToken}
        />
        {
          showModalAddBot &&
          <DialogAddBotPure
            templates={props.botTemplates}
            loadingTemplates={props.loadingBotTemplates}
            onClose={() => setShowModalAddBot(false)}
            onSubmit={(e) => props.handleCreateNewAssistant(e.chatbotName, e.templateId)}
          />
        }
      </div>
    </Fragment >
  )
}

export default withRouter(AppView)
